import { render, staticRenderFns } from "./SuperPopup.vue?vue&type=template&id=4a202507&scoped=true"
import script from "./SuperPopup.vue?vue&type=script&lang=js"
export * from "./SuperPopup.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./SuperPopup.vue?vue&type=style&index=1&id=4a202507&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a202507",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a202507')) {
      api.createRecord('4a202507', component.options)
    } else {
      api.reload('4a202507', component.options)
    }
    module.hot.accept("./SuperPopup.vue?vue&type=template&id=4a202507&scoped=true", function () {
      api.rerender('4a202507', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingCampaign/components/SuperPopup.vue"
export default component.exports